export default __webpack_public_path__ + "static/celedumapy_grafika-49928e04b780db22404e34de0334d2ec.svg";